import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const FloatingButtons: React.FC = () => {
  const { t } = useTranslation();
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 200);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <div style={{ position: 'fixed', right: 24, bottom: 24, zIndex: 60, display: 'flex', flexDirection: 'column', gap: 12 }}>
      <AnimatePresence>
        {showTop && (
          <motion.button
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={scrollToTop}
            aria-label={t('scrollToTop')}
            title={t('scrollToTop')}
            style={{
              background: 'var(--primary-dark)',
              color: 'white',
              border: 'none',
              padding: '12px',
              borderRadius: '999px',
              boxShadow: '0 10px 30px rgba(0,0,0,0.12)',
              cursor: 'pointer'
            }}
          >
            <i className="fas fa-arrow-up" style={{ fontSize: 16 }}></i>
          </motion.button>
        )}
      </AnimatePresence>
    </div>
  );
};

export default FloatingButtons;